import { useEffect, useState } from "react";
import formatMoney from "../../formatMoney";
import {
  getPurchaseCount,
  getTotalGross,
  getStatusBackgroundColor,
  areAllObjectsPending,
} from "./utils";
import InputFactory from "../InputFactory";
import { object } from "motion/react-client";

function MonthCard({
  month,
  year,
  onView,
  objects,
  find,
  type,
  onSelect,
  selected,
  isAdmin,
}) {
  const [totalGross, setTotalGross] = useState("");
  const [totalPurchase, setTotalPurchase] = useState(0);
  const [statusBgColor, setStatusBgColor] = useState(undefined);
  const [allPending, setAllPending] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const grossTotal = getTotalGross(objects, month, year);
    const purchaseCount = getPurchaseCount(objects, month, year);
    const bgColor = getStatusBackgroundColor(objects, month, year);
    const pending = areAllObjectsPending(objects, month, year);

    setTotalGross(grossTotal);
    setTotalPurchase(purchaseCount);
    setStatusBgColor(bgColor);
    setAllPending(pending);
  }, [objects, month, year]);

  const selectedList = selected ?? [];
  const isSelected = selectedList.some(
    (s) => s.month === month && s.year === year,
  );

  const hasObjects = totalPurchase > 0;
  const isSelectable = hasObjects && !isAdmin && !!onSelect && allPending;
  const showCheckbox = hasObjects && !isAdmin && allPending;

  const _onSelect = (e) => {
    if (!isSelectable || !onSelect) {
      e?.preventDefault?.();
      e?.stopPropagation?.();
      return;
    }
    e?.stopPropagation?.();
    onSelect(month, year);
  };

  return (
    <div className="col-6">
      <div
        role="button"
        tabIndex={isSelectable ? 0 : -1}
        className={`card rounded-3 border-1 ${isSelectable ? "cursor-pointer" : "cursor-not-allowed"} border-primary position-relative`}
        style={{
          backgroundColor: isSelected ? "#e9ffcf" : statusBgColor || undefined,
          transition: "transform 0.2s ease",
          ...(isSelectable && isHovered && { transform: "translateY(-2px)" }),
        }}
        onMouseEnter={() => isSelectable && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={_onSelect}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            _onSelect(e);
          }
        }}
      >
        {showCheckbox && (
          <label
            className="position-absolute d-flex align-items-center justify-content-center rounded"
            style={{
              top: "1rem",
              left: "1rem",
              width: 20,
              height: 20,
              border: `1px solid ${isSelected ? "#8bc34a" : "#283754"}`,
              backgroundColor: isSelected ? "#8bc34a" : "transparent",
              cursor: isSelectable ? "pointer" : "not-allowed",
              transition: "border-color 0.2s ease, background-color 0.2s ease",
            }}
            onClick={(e) => e.stopPropagation()}
            aria-hidden
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={_onSelect}
              disabled={!isSelectable}
              style={{
                position: "absolute",
                opacity: 0,
                width: "100%",
                height: "100%",
                margin: 0,
                cursor: isSelectable ? "pointer" : "not-allowed",
              }}
              aria-label={`Select ${month} ${year}`}
            />
            {isSelected && (
              <span
                style={{
                  color: "#fff",
                  fontSize: "0.95rem",
                  fontWeight: "bold",
                  lineHeight: 1,
                }}
              >
                ✓
              </span>
            )}
          </label>
        )}

        <div className="card-body d-flex flex-column align-items-center gap-3">
          <h4 className="card-title mb-0 text-primary fw-semibold fs-5">
            {month}
          </h4>
          <div className="d-flex flex-column" style={{ fontSize: "0.8rem" }}>
            <div className="d-flex gap-2">
              <p className="text-muted m-0">
                {type === "sales" ? "No. of Sales: " : "Total Purchase: "}
              </p>
              <b className="m-0">{totalPurchase}</b>
            </div>
            <div className="d-flex gap-2 flex-column flex-md-row">
              <p className="text-muted m-0">Total Gross Amount: </p>
              <b className="m-0 text-center">&#8369; {totalGross}</b>
            </div>
          </div>

          <button
            type="button"
            className="btn btn-outline-primary text-light col-12 col-md-8 col-lg-5 bg-primary fw-medium"
            onClick={(e) => {
              e.stopPropagation();
              onView(month, year);
            }}
            disabled={(isAdmin && allPending === 0) || (isAdmin && allPending)}
          >
            View
          </button>
        </div>
      </div>
    </div>
  );
}

export default MonthCard;
